'use client';

import { useAuth } from 'react-oidc-context';

import { getConfig } from '@zoomit/configs';
import { AvatarScratch, Logout } from '@zoomit/icons';
import { Sheet } from '@zoomit/mobile-sheet';
import { Link } from '@zoomit/primitives';
import { BaseMediaUrl, LogoutModal, NotificationBody, useHistoryState, useLogout } from '@zoomit/web-kit';
import { Avatar, Button, cssVar, TextIcon, theme, Typography } from '@zoomit/zoomit-ds';

import { NavbarWithClose } from '../Navbar';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ProfileSheet = (props: Props) => {
  const { isOpen, onClose } = props;

  const { isLoading: signOutLoading, mutate: handleSignOut } = useLogout();
  const logoutModal = useHistoryState({
    id: 'logout-modal',
  });

  const { user } = useAuth();

  return (
    <Sheet isOpen={isOpen} onClose={onClose} disableDrag>
      <Sheet.Container hasBorderRadius={true} isFullScreen>
        <Sheet.Header>
          <NavbarWithClose onClose={onClose} />
        </Sheet.Header>
        <div className="px-4">
          <div className="mt-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              {user?.profile.picture ? (
                <Avatar size="medLarge" src={`${BaseMediaUrl}/${user.profile.picture}`} />
              ) : (
                <AvatarScratch size="lx" fill={cssVar(theme.grey1)} />
              )}
              <Typography fontSize={1.4} fontWeight={700}>
                {user?.profile.name}
              </Typography>
            </div>
            <div className="items-center gap-4">
              <TextIcon
                className={'cursor-pointer'}
                rightIcon={<Logout size="sm" />}
                onClick={logoutModal.open}
              >
                <Typography fontSize={1.2} fontWeight={400}>
                  خروج
                </Typography>
              </TextIcon>
            </div>
          </div>
          <Link href={getConfig('ID4_ISSUER') as string}>
            <Button className="my-4" variant="outline" size="full width">
              ویرایش اطلاعات کاربری
            </Button>
          </Link>
        </div>
        {logoutModal.isOpen && (
          <LogoutModal onClose={logoutModal.close} isLoading={signOutLoading} mutate={handleSignOut} />
        )}
        <NotificationBody showAllButton={false} onClose={onClose} />
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};

export default ProfileSheet;
